import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import ValidationGroup from "../../common/ValidationGroup";
import Table from "../../common/Table";
import * as types from "../../../constants/ComponentConstants";
import Section from "../../common/Section";
import TochtenRows from "./parts/TochtenRows";
import InSamenWerkingMetLogos from "../../common/InSamenWerkingMetLogos";

const KalenderGoedkeurenForm = (props) => {
    const {
        model,
        onChangeRedenVanAfkeuring,
        onChangeGoedkeuren,
        onSave,
        errors,
        validationMessageType,
        provincie
    } = props;

    if (!model.heeftToegangTotPagina)
        return "Je hebt geen toegang tot deze pagina";

    const tochtenTabelHeaderSizes = [20, 11, 18, 15, 28, 8];

    return (
        <Fragment>
            {(!model.tochten.length) ?
                <Section>
                    <p>Geen tochten gevonden</p>
                </Section>
                :
                null
            }
            {(model.tochten.length === 0) ||
                <Section
                    title={`Goed te keuren tochten : ${provincie}`}
                    color={types.COLOR_BLUE}
                >
                    <Form name="federatieOverzicht"
                        title=""
                        headerVisible={false}
                        isNotRequired
                        leftButtonLabel={"Bewaar"}
                        onLeftButtonClick={onSave}>
                        <Section>
                            <ValidationGroup messages={errors ? errors['tochten'] : undefined}>
                                <Table
                                    headers={["organisator", "datum", "startgemeente", "goedgekeurd", "reden", ""]}
                                    headerSizes={tochtenTabelHeaderSizes}
                                >
                                    <TochtenRows
                                        tochten={model.tochten}
                                        onChangeRedenVanAfkeuring={onChangeRedenVanAfkeuring}
                                        onChangeGoedkeuren={onChangeGoedkeuren}
                                        errors={errors}
                                        validationMessageType={validationMessageType} />
                                </Table>
                            </ValidationGroup>
                        </Section>
                    </Form>
                </Section>
            }
            <InSamenWerkingMetLogos />
        </Fragment>);
};

KalenderGoedkeurenForm.propTypes = {
    model: PropTypes.object,
    onChangeRedenVanAfkeuring: PropTypes.func.isRequired,
    onChangeGoedkeuren: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    errors: PropTypes.object,
    validationMessageType: PropTypes.string,
    provincie: PropTypes.string.isRequired
};

export default KalenderGoedkeurenForm;